export enum ConfigEnum {
  Production = 'production',
  LaunchDarkleyClientKey = 'ldClientKey',
  AccountsApiUrl = 'accountsApiUrl',
  V3ApiUrl = 'v3ApiUrl',
  Auth0Subdomain = 'auth0Subdomain',
  Auth0Domain = 'auth0Domain',
  Auth0Audience = 'auth0Audience',
  Auth0Scope = 'auth0Scope',
  Auth0Users = 'auth0Users',
  Auth0ClientId = 'auth0ClientId',
  TenantId = 'tenantId',
}
